export const MaxWidthNameColumn = '25em'
